import { render, staticRenderFns } from "./CreateInventoryModal.vue?vue&type=template&id=720ef518&scoped=true&"
import script from "./CreateInventoryModal.vue?vue&type=script&lang=js&"
export * from "./CreateInventoryModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateInventoryModal.vue?vue&type=style&index=0&id=720ef518&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720ef518",
  null
  
)

export default component.exports